export default __webpack_public_path__ + "static/media/lightning.d8fd089f.svg";